import { createIcon } from "@chakra-ui/react";

export const Dots = createIcon({
  displayName: "Dots",
  viewBox: "0 0 24 24",
  d: "M11.807 8.181c.998 0 1.807-.825 1.807-1.84 0-1.016-.81-1.841-1.807-1.841C10.81 4.5 10 5.325 10 6.34c0 1.016.81 1.841 1.807 1.841zm0 5.26c.998 0 1.807-.825 1.807-1.841s-.81-1.84-1.807-1.84c-.997 0-1.807.824-1.807 1.84s.81 1.84 1.807 1.84zm1.807 3.418c0-1.015-.81-1.84-1.807-1.84-.997 0-1.807.825-1.807 1.84 0 1.016.81 1.841 1.807 1.841.998 0 1.807-.825 1.807-1.84z",
  defaultProps: {
    "aria-label": "Three dots stacked vertically"
  }
});

export default Dots;
